import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { installChunkReloadGuard } from '@provenance/design';
import { App } from './App';
import { UpdateWatcher } from './UpdateWatcher';
import { RELEASE } from './release';
import './index.css';

installChunkReloadGuard(RELEASE);

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <UpdateWatcher />
    </BrowserRouter>
  </StrictMode>,
);
